export default __webpack_public_path__ + "static/media/menu-chat-active.c35ac1eb.svg";